var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-container',[_c('v-row',_vm._l((_vm.tasks),function(item){return _c('CardPickupQuickView',{key:item.id,attrs:{"task_id":item.id,"type":_vm.type}})}),1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }